import React from 'react';

const TaskContext = React.createContext();
const ColumnContext = React.createContext();
const PermissionContext = React.createContext();
const ParentOriginContext = React.createContext()

export { TaskContext, ColumnContext, PermissionContext,ParentOriginContext };